import {NgModule} from '@angular/core';
import {VersionTagTypeToDisplayNamePipe} from './version-tag-type-to-display-name.pipe';

@NgModule({
  declarations: [VersionTagTypeToDisplayNamePipe],
  exports: [VersionTagTypeToDisplayNamePipe],
})
export class VersionTagTypeToDisplayNameModule {}
